import React, { useContext } from 'react';
import { Box, Grid, TextField } from '@mui/material';
import dayjs from 'dayjs';
import { Field, Formik, Form } from 'formik';
import { object, string } from 'yup';
import { Send } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import PieCounter from './PieCounter';
import OrdersContext from '../../Context/Orders/OrdersContext';
import DateTime from './DateTime';

export default function NewOrderForm() {
	const { newOrder, addNewOrder, isLoading, toogleIsLoading } =
		useContext(OrdersContext);

	return (
		<>
			<Formik
				initialValues={newOrder}
				validationSchema={object({
					name: string()
						.required('Es un campo requerido')
						.min(1, 'El folio debe contener mínimo 1 carácteres'),
					placeOfDelivery: string().required('Es un campo requerido'),
				})}
				validateOnMount
			>
				{({
					errors,
					isValid,
					touched,
					dirty,
					values,
					// resetForm,
					setFieldValue,
					// validateForm,
				}) => (
					<Form>
						<Field
							required
							margin='dense'
							id='name'
							name='name'
							value={values.name}
							as={TextField}
							label='Nombre'
							type='text'
							fullWidth
							variant='outlined'
							error={errors.name && touched.name}
							helperText={touched.name && errors.name}
						/>
						<Field
							multiline
							margin='dense'
							id='description'
							name='description'
							value={values.description}
							as={TextField}
							label='Descripción'
							type='text'
							fullWidth
							variant='outlined'
						/>
						<DateTime
							disablePast
							value={
								values.dateOfDelivery
									? values.dateOfDelivery
									: setFieldValue('dateOfDelivery', dayjs().format())
							}
							onChange={(newValue) => {
								setFieldValue('dateOfDelivery', dayjs(newValue).format());
							}}
							id='dateOfDelivery'
							name='dateOfDelivery'
							label='Fecha de entrega'
							variant='outlined'
							renderInput={(props) => (
								<TextField {...props} fullWidth margin='dense' required />
							)}
						/>
						<Field
							required
							margin='dense'
							id='placeOfDelivery'
							name='placeOfDelivery'
							value={values.placeOfDelivery}
							as={TextField}
							label='Lugar de entrega'
							type='text'
							fullWidth
							variant='outlined'
							error={errors.placeOfDelivery && touched.placeOfDelivery}
							helperText={touched.placeOfDelivery && errors.placeOfDelivery}
						/>
						<Grid container>
							{values?.items?.map(({ name, label, value, id, category }) => (
								<Grid item xs={12} xsm={6} key={name}>
									{category === 'whole' ? (
										<Field
											// eslint-disable-next-line react/no-unstable-nested-components
											as={PieCounter}
											margin='dense'
											id={name}
											name={`items[${id}].value`}
											onChange={(e) => {
												setFieldValue(`items[${id}].value`, e.target.value);
											}}
											value={value}
											text={`${label}`}
											type='number'
											fullWidth
											variant='outlined'
											InputProps={{
												inputProps: { min: 0, style: { textAlign: 'center' } },
											}}
										/>
									) : (
										<Field
											// eslint-disable-next-line react/no-unstable-nested-components
											as={PieCounter}
											margin='dense'
											id={name}
											name={`items[${id}].value`}
											onChange={(e) => {
												setFieldValue(`items[${id}].value`, e.target.value);
											}}
											value={value}
											text={`${label} (rebanada)`}
											type='number'
											fullWidth
											variant='outlined'
											InputProps={{
												inputProps: { min: 0, style: { textAlign: 'center' } },
											}}
										/>
									)}
								</Grid>
							))}
						</Grid>
						<Box
							sx={{
								margin: '0 auto',
								padding: '16px 0 8px 0',
								textAlign: 'center',
							}}
						>
							<LoadingButton
								disabled={
									!(
										isValid &&
										dirty &&
										(values.items[0].value ||
											values.items[1].value ||
											values.items[2].value ||
											values.items[3].value)
									)
								}
								onClick={() => {
									toogleIsLoading(true);
									addNewOrder(values);
								}}
								endIcon={<Send />}
								loading={isLoading}
								loadingPosition='end'
								variant='contained'
							>
								Hacer pedido
							</LoadingButton>
						</Box>
					</Form>
				)}
			</Formik>
		</>
	);
}
